var _linearGradient, _linearGradient2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    overflow: "scroll",
    viewBox: "7.592 13.58 48.54 36.42",
    xmlns: "http://www.w3.org/2000/svg",
    width: 2500,
    height: 1394,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 14.001,
    x2: 32,
    y1: 30.744,
    y2: 30.744
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cdcdcd"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 28.665,
    x2: 50,
    y1: 36.447,
    y2: 36.447
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2e2e2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53 50H11a3 3 0 01-3-3V17a3 3 0 013-3h42a3 3 0 013 3v30a3 3 0 01-3 3z",
    fill: "#eaeaea"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 50h-3a3 3 0 01-3-3V17a3 3 0 116 0z",
    fill: "#d54c3f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50 50h3a3 3 0 003-3V17a3 3 0 10-6 0z",
    fill: "#b63524"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.718 19.46a3 3 0 10-3.436-4.92l-19.28 14.037-.002.001-.002-.001-19.28-14.037a3 3 0 00-3.436 4.92l-.08-.059L32 36m22.799-16.599L32 36",
    fill: "#de5145"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53 14c-.639 0-1.232.2-1.718.54l-19.28 14.037-.002.001-.002-.001-19.28-14.037A2.988 2.988 0 0011 14z",
    fill: "#efefef"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.001 24.188L8.945 19.18l-.002.004c.106.1.219.192.339.276l-.08-.059 4.8 3.495-.001 1.328",
    fill: "#c64132"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.668 38.591L14 50l.001-25.937 14.664 14.524",
    fill: "#e3e3e3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.668 38.591L32 36 14.001 22.896v1.167l14.664 14.524z",
    fill: "url(#a)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.061 50H50V22.895L32 36l-3.335 2.587z",
    fill: "url(#b)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.acf172126abc6d2044b2a80b8c0523f7.svg";
export { ForwardRef as ReactComponent };